module.exports = __webpack_public_path__ + "assets/graph.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/graph.svg
// module id = 1201
// module chunks = 7